import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wrapper-admin',
  templateUrl: './wrapper-admin.component.html',
  styleUrls: ['./wrapper-admin.component.scss']
})
export class WrapperAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
